import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import AddVentaRapidaForm from "../components/AddVentaRapidaForm";
import "../css/admin.css";

const VentaRapida = () => {
  const [usuario, setUsuario] = useState({});

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode = jwt_decode(token);
        setUsuario(token_decode.usuario || {});
      } catch (e) {
        console.error("❌ Error al decodificar token:", e);
        setUsuario({});
      }
    }
  }, [token]);

  const puedeVerVentaRapida = [
    "ROOT_ROLE",
    "ADMIN_ROLE",
    "MANAGER_ROLE",
    "VENDEDOR_ROLE",
  ].includes(usuario?.role);

  return (
    <div className="cabecera venta-rapida-page">
      {token ? (
        <div className="container mt-5 mb-5">
          {puedeVerVentaRapida ? (
            <>
              <h3 className="mt-3 mb-2">VENTA RÁPIDA</h3>
              {/* <div className="alert alert-light border small mb-3">
                Nueva modalidad de carga. No reemplaza el formulario actual.
              </div> */}

              <hr />

              <AddVentaRapidaForm />
            </>
          ) : (
            <div className="alert alert-info" role="alert">
              Lo sentimos, pero no tiene permisos para acceder a este contenido.
            </div>
          )}
        </div>
      ) : (
        <div className="container mt-5">
          <div className="alert alert-danger" role="alert">
            No se encuentra logueado en la plataforma.
          </div>
        </div>
      )}
    </div>
  );
};

export default VentaRapida;